import '../../styles/style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faStopwatch } from '@fortawesome/free-solid-svg-icons';
import { LineChart } from '@mui/x-charts/LineChart';
import HeaderBar from './HeaderBar';
import { useData, usePunishments } from './MemberData';
import { useState, useEffect, useRef } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from "dayjs";
import toast, { Toaster } from 'react-hot-toast';
import Cookies from 'js-cookie';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import Swal from 'sweetalert2';
import axios from 'axios';

let dutyStatus = '';
let myDiscordID = ''
interface Member {
    user_id: number;
    full_name: string;
    callsign: number;
    entry_date: string | Date;
    last_up: string | Date;
    discordID: string;
    functions?: Record<string, boolean | string>;
    certificates?: Record<string, boolean | string>;
    fw: number;
    notes: string;
    grade: string;
    reintegrated: boolean;
    email: string;
}

interface Logs{
    type: string;
    member: string;
    pType: string;
    date_time: string;
}

interface Demisie{
    callsign: number;
    id: number;
    rank: string;
    type: string;
    reason: string;
}

interface Concediu{
    callsign: number;
    name: string;
    startDate: string;
    endDate: string;
    reason: string;    
    status: Boolean;
    days: number;
}

interface ActivityData{
    callsign: number;
    days: string;
    report: string
}

interface Invoire{
    callsign: number;
    reason: string;
    type: string;
    status: Boolean;
}

interface Contestatie{
    callsign: number;
    tip: string;
    nume: string;
    dovada: string;
    tipcontestatie: string;
}

const options = [
  "REMOVE", "RADIO", "MDT", "HR", "PR", "DSI",
  "FTO", "PILOT", "MOTO", "HS", "PCLS", "TESTER"
];

interface CustomSelectModalProps {
  statusModal: boolean;
  handleStatusModalClose: () => void;
  handleChangeStatus: (value: string) => void;
  setStatus: () => void;
  statusStyle: React.CSSProperties;
}

const CustomSelectModal: React.FC<CustomSelectModalProps> = ({
  statusModal,
  handleStatusModalClose,
  handleChangeStatus,
  setStatus,
  statusStyle
}) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const handleSelect = (value: string) => {
    dutyStatus = value;
    handleChangeStatus(value); 
    setOpenDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: { target: any; }) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setOpenDropdown(false);
        }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={statusModal}
      onClose={handleStatusModalClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={statusModal}>
        <Box sx={statusStyle} className="flex flex-col items-center relative">
          <span className="text-white font-semibold text-[1vw] w-full text-center">STATUS PONTAJ</span>

          <div ref={dropdownRef} className="relative w-[50%] mt-[3%]">
            <button
              onClick={() => setOpenDropdown(!openDropdown)}
              className="w-full bg-[#272727] text-white border border-gray-500 px-4 py-2 rounded-md text-left hover:bg-[#353535]"
            >
              {dutyStatus || "Alege status"}
            </button>
            {openDropdown && (
              <ul className="absolute z-[2000] w-full bg-[#272727] border border-gray-600 mt-1 rounded-md max-h-48 overflow-y-auto shadow-lg">
                {options.map((option) => (
                  <li
                    key={option}
                    onClick={() => handleSelect(option)}
                    className="px-4 py-2 text-white hover:bg-[#3b3b3b] cursor-pointer"
                  >
                    {option}
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div
            onClick={setStatus}
            className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]"
          >
            <span className="text-white font-bold text-[1.1vw]">SETEAZĂ STATUS</span>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

const API_URL = 'http://panelpolitie.fplayt.ro:5001';

const refreshAccessToken = async () => {
  try {
    const response = await axios.post(`${API_URL}/api/token`, {
      refreshToken: localStorage.getItem("refreshToken")
    });
    const { accessToken } = response.data;
    localStorage.setItem("token", accessToken);
    return accessToken;
  } catch (error) {
    throw new Error("Unable to refresh token");
  }
};

const makeAuthenticatedRequest = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    return await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (err: any) {
    if (err.response.status === 403 || err.response.data?.error === "Invalid token") {
      try {
        const newToken = await refreshAccessToken();
        return await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${newToken}`
          }
        });
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        throw new Error("Session expired. Please log in again.");
      }
    } else {
      throw err;
    }
  }
};

function HomePage() {   
    const { membersPunishments } = usePunishments();
    const { policeMembersData, penitenciarMembersData, allMembersData, getPoliceMemberInfo, getPenMemberInfo, getDiscordIDType, getPenDiscordMemberInfo, getPoliceDiscordMemberInfo, fetchData } = useData();
    const [logsHR, setLogs] = useState<Logs[]>([]);
    const [openConcediu, setOpenConcediu] = useState(false);
    const [openDemisie, setOpenDemisie] = useState(false);
    const [openInvoire, setOpenInvoire] = useState(false);
    const [activeFines, setActiveFines] = useState(0);
    const [isConducere, setIsConducere] = useState(false);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [reason, setReason] = useState("");
    const [myData, setMyData] = useState<Member | null>(null);
    const [activeDemisiiOpen, setActiveDemisiiOpen] = useState(false);
    const [activeDemisii, setDemisiiActive] = useState<Demisie[]>([])
    const [activeConcediiOpen, setActiveConcediiOpen] = useState(false);
    const [activeConcedii, setConcediiActive] = useState<Concediu[]>([]);
    const [data, setData] = useState<number[]>([0, 0, 0, 0, 0, 0, 0]);
    const [activeInvoiriOpen, setActiveInvoiriOpen] = useState(false);
    const [activeInvoiri, setActiveInvoiri] = useState<Invoire[]>([]);
    const [statusModal, openStatusModal] = useState(false);

    useEffect(() => {
        let isConducereTemp = false;
        myDiscordID = Cookies.get('myDiscordID') || '';
        if (myDiscordID === '') {
            let email = Cookies.get('email');
            for (let index = 0; index < allMembersData.length; index++) {
                const element = allMembersData[index];
                if (element.email === email) {
                    Cookies.set("myDiscordID", element.discordID)
                    myDiscordID = element.discordID
                    setMyData(element);
                }
            }
        }
        for (let index = 0; index < allMembersData.length; index++) {
            const member = allMembersData[index];
            if (member.discordID === myDiscordID) {
                setMyData(member);
            }
            if (member.grade === "SUB-INSPECTOR" || member.grade === "INSPECTOR" ||member.grade === "INSPECTOR-PRINCIPAL" || member.grade === "SUB-COMISAR" || member.grade === "COMISAR" || member.grade === "COMISAR-SEF" || member.grade === "CHESTOR-GENERAL") {
                if (member.discordID === myDiscordID) {
                    isConducereTemp = true;
                }
            }
        }

        updateGraph();
        checkFines();
        loadHRLogs();
        setIsConducere(isConducereTemp);
    }, [allMembersData, myDiscordID]);

    const updateGraph = async () => {
        try {
            const response = await axios.get<ActivityData[]>(
                `${API_URL}/api/activityByCS?callsign=${getDiscordIDType(myDiscordID) === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "callsign") : getPenDiscordMemberInfo(myDiscordID, "callsign")}&type=${getDiscordIDType(myDiscordID)}`
            );
            if (response.data[0]) {
                response.data[0].days = JSON.parse(response.data[0].days).map((day: string | null) => {
                    return (day === null || day === "-" || day === "CO") ? 0 : Number(day);
                });
                setData([Number(response.data[0].days[0]), Number(response.data[0].days[1]), Number(response.data[0].days[2]), Number(response.data[0].days[3]), Number(response.data[0].days[4]), Number(response.data[0].days[5]), Number(response.data[0].days[6])]);
                saveToLocalStorage("timerData", [Number(response.data[0].days[0]), Number(response.data[0].days[1]), Number(response.data[0].days[2]), Number(response.data[0].days[3]), Number(response.data[0].days[4]), Number(response.data[0].days[5]), Number(response.data[0].days[6])]);
            } else {
                setData([0,0,0,0,0,0,0])
            }
        } catch (err) {
            console.log(err)
            toast.error("A apărut o eroare la actualizarea graficului!");
        }
    }

    async function loadHRLogs() {
        try {
            const response = await axios.get(`${API_URL}/logs/get`);
            if (response.data) {
                setLogs(response.data.reverse());
            } else {
                console.log("No data in hrlogs");
                return;
            }
        } catch (err) {
            console.log(err);
        }
    }

    async function checkFines() {
        let finesCount = 0;
        try {
            for (let index = 0; index < membersPunishments.length; index++) {
                const element = membersPunishments[index];
                if (JSON.parse(element.punishments).status === false && element.pType === "fine") {
                    finesCount++;
                }
            }
            setActiveFines(finesCount);
        } catch (err) {
            console.log(err);
            toast.error("A apărut o eroare! Amenzile active nu au fost încărcate!");
        }
    }
    
    const concediuStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '30%',
        height: '42%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: '#202020',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };

    const demisieStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '30%',
        height: '25%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: '#202020',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };

    const invoireStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '30%',
        height: '25%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: '#202020',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };

    const activeStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '45%',
        height: '60%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: '#191919',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };    

    const contestatieStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '45%',
        height: '70%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: '#191919',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    }

    const activeCStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '65%',
        height: '60%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: '#191919',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };    

    const statusStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '35%',
        height: '25%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: '#191919',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 2,
    };
    
    function openConcediuModal() {
        setOpenConcediu(true);
    }

    function openDemisieModal() {
        setOpenDemisie(true);
    }

    function openInvoireModal() {
        setOpenInvoire(true);
    }


    async function openDemisiiModal() {
        try {
            const response = await axios.get(`${API_URL}/api/getActiveDemisii`);
            if (response.data) {
                setDemisiiActive(response.data);
                setActiveDemisiiOpen(true);
            } else {
                console.log("No data in activeDemisii");
                return;
            }
        } catch (err) {
            console.log(err);
        }
    }

    const rejectDemisie = async (callsign: number, type: string) => {
        try {
            const response = await makeAuthenticatedRequest(`${API_URL}/requests/rejectDemisie`, {
                callsign: callsign,
                type: type
            })
            if (response.statusText === "OK") {
                toast.error("Ai respins cererea de demisie!")
                openDemisiiModal()
            } else {
                toast.error("A apărut o eroare! Concediul nu a fost respins!");
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A apărut o eroare! Concediul nu a fost respins!");
            }
        }
    }

    const handleDemisiiClose = () => {
        setActiveDemisiiOpen(false);
    }
    
    const handleCloseModal = () => {
        setOpenConcediu(false);
        setOpenDemisie(false);
        setOpenInvoire(false);
    };

    const validateConcediuForm = () => {
        let isValid = true;
        if (!startDate && !endDate && !reason.trim()) {
            toast.error("Toate câmpurile sunt obligatorii!");
            isValid = false;
        }
        if (startDate && endDate && startDate > endDate) {
            toast.error("Dată începere inactivitate nu poate fi după Dată încheiere concediu!");
            isValid = false;
        }
        return isValid;
    };

    const handleConcediuSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (validateConcediuForm()) {
            let type = getDiscordIDType(myDiscordID);
            let actualCallsign;
            if (type === "pol") {
                actualCallsign = getPoliceDiscordMemberInfo(myDiscordID, "callsign");
            } else if (type === "pen") {
                actualCallsign = getPenDiscordMemberInfo(myDiscordID, "callsign");
            }
            let daysOff = 0;
            if (getDiscordIDType(myDiscordID) === "pol") {
                daysOff = getPoliceDiscordMemberInfo(myDiscordID, "concediu");
            } else if (getDiscordIDType(myDiscordID) === "pen") {
                daysOff = getPenDiscordMemberInfo(myDiscordID, "concediu");
            } else {
                toast.error("Nu poți face această acțiune la academie!");
                return;
            }
            if (daysOff === 0) {
                toast.error("Nu mai ai zile de concediu rămase!");
                return;
            }
            const date = startDate ? new Date(startDate) : null;
            const date2 = endDate ? new Date(endDate) : null;

            const formattedStartDate = `${
            ((date?.getMonth() ?? 0) + 1).toString().padStart(2, '0')}/${
            date?.getDate().toString().padStart(2, '0')}/${
            date?.getFullYear()}`;
            const formattedEndDate = `${
                ((date2?.getMonth() ?? 0) + 1).toString().padStart(2, '0')}/${
                date2?.getDate().toString().padStart(2, '0')}/${
                date2?.getFullYear()}`;

            const diffTime = Math.abs(new Date(formattedEndDate).getTime() - new Date(formattedStartDate).getTime());
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))+1; 
            
            if (diffDays > daysOff) {
                toast.error("Nu ai suficiente zile de concediu rămase!");
                return;
            } else {
                const formData = {
                    callsign: actualCallsign,
                    startDate: startDate?.toLocaleDateString(),
                    endDate: endDate?.toLocaleDateString(),
                    reason: reason,
                    nume: getDiscordIDType(myDiscordID) === 'pol' ? getPoliceDiscordMemberInfo(myDiscordID, "full_name") : getPenDiscordMemberInfo(myDiscordID, "full_name")
                };
                try {
                    const response = await makeAuthenticatedRequest(`${API_URL}/requests/concediu`, {
                        type: getDiscordIDType(myDiscordID),
                        days: diffDays,
                        formData: formData
                    });
                    if (response.statusText === "OK") {
                        toast.success("Zile concediu ramase: " + (daysOff - diffDays));
                        setOpenConcediu(false);
                        fetchData();
                    } else {
                        toast.error("A apărut o eroare! Cererea de concediu nu a fost trimisă!");
                        return;
                    }
                } catch (err: any) {
                    if (err.response.data.error === "Invalid token") {
                        toast.error("Token invalid! Te rugăm să te reconectezi.");
                        localStorage.removeItem("token");
                    } else {
                        toast.error("A apărut o eroare! Cererea de concediu nu a fost trimisă!");
                    }
                }
            }
        }
    };

    const handleDemisieSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        let type = getDiscordIDType(myDiscordID);
        let actualCallsign;
        if (type === "pol") {
            actualCallsign = getPoliceDiscordMemberInfo(myDiscordID, "callsign");
        } else if (type === "pen") {
            actualCallsign = getPenDiscordMemberInfo(myDiscordID, "callsign");
        } else if (type === "ac") {
            toast.error("Nu poți face această acțiune la academie!");
            return;
        }
        const formData = {
            callsign: actualCallsign,
            nume: type === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "full_name") : getPenDiscordMemberInfo(myDiscordID, "full_name"),
            user_id: type === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "user_id") : getPenDiscordMemberInfo(myDiscordID, "user_id"),
            grad: type === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "grade") : getPenDiscordMemberInfo(myDiscordID, "grade"),
            reason: reason,
        };
        try {
            const response = await makeAuthenticatedRequest(`${API_URL}/requests/demisie`, {
                type: getDiscordIDType(myDiscordID),
                formData: formData
            });
            if (response.statusText === "OK") {
                toast.success("Cererea de demisie a fost trimisă către conducere!");
                setOpenDemisie(false);
            } else {
                toast.error("A apărut o eroare! Cererea de demisie nu a fost trimisă!");
                return;
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A apărut o eroare! Cererea de demisie nu a fost trimisă!");
            }
        }
    };

    const handleInvoireSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        let type = getDiscordIDType(myDiscordID);
        let actualCallsign;
        if (type === "pol") {
            actualCallsign = getPoliceDiscordMemberInfo(myDiscordID, "callsign");
        } else if (type === "pen") {
            actualCallsign = getPenDiscordMemberInfo(myDiscordID, "callsign");
        } else if (type === "ac") {
            toast.error("Nu poți face această acțiune la academie!");
            return;
        }
        try {
            const formData = {
                callsign: actualCallsign,
                reason: reason,
                nume: getDiscordIDType(myDiscordID) === 'pol' ? getPoliceDiscordMemberInfo(myDiscordID, "full_name") : getPenDiscordMemberInfo(myDiscordID, "full_name")
            };
            const response = await makeAuthenticatedRequest(`${API_URL}/requests/invoire`, {
                callsign: actualCallsign,
                reason: reason,
                type: getDiscordIDType(myDiscordID),
                formData: formData
            })
            if (response.statusText === "OK") {
                toast.success("Cererea de învoire a fost trimisă către conducere!");
                setReason("");
                setOpenInvoire(false);
            } else {
                toast.error("A apărut o eroare! Cererea nu a fost trimisă.")
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A apărut o eroare! Cererea nu a fost trimisă.")
            }
        }
    };

    const handleConcediiOpen = async () => {
        try {
            const response = await axios.get(`${API_URL}/get/concedii`);
            if (response) {
                if (response.data) {
                    setConcediiActive(response.data);
                }
                setActiveConcediiOpen(true);
            } else {
                toast.error("Nicio cerere de concediu activă!")
                return;
            }
        } catch (err) {
            console.log(err);
            toast.error("A apărut o eroare! Cererile de concediu nu au fost încărcate!");
        }
    }

    const autofillActivityData = async (callsign: number, reason: string, days: number) => {
        try {
            const response = await makeAuthenticatedRequest(`${API_URL}/requests/acceptConcediu`, {
                callsign: callsign,
                reason: reason,
                days: days
            })
            if (response.statusText === "OK") {
                toast.success("Ai acceptat concediul!")
            } else {
                toast.error("A apărut o eroare! Concediul nu a fost șters dar a fost trecut!");
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A apărut o eroare! Concediul nu a fost șters dar a fost trecut!");
            }
        }
        handleConcediiOpen();
    };

    const acceptConcediu = async (callsign: number, reason: string, days: number) => {
        autofillActivityData(callsign, reason, days);
        handleConcediiOpen();
    }

    const rejectConcediu = async (callsign: number, reason: string) => {
        try {
            const response = await makeAuthenticatedRequest(`${API_URL}/requests/rejectConcediu`, {
                callsign: callsign,
                reason: reason
            })
            if (response.statusText === "OK") {
                toast.error("Ai respins cererea de concediu!")
                handleConcediiOpen()
            } else {
                toast.error("A apărut o eroare! Concediul nu a fost respins!");
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A apărut o eroare! Concediul nu a fost respins!");
            }
        }
    }
    
    const handleConcediiClose = () => {
        setActiveConcediiOpen(false);
    }
    
    const [startTime, setStartTime] = useState<number | null>(null);
    const [isRunning, setIsRunning] = useState<boolean>(false);
    const [elapsedTime, setElapsedTime] = useState<number>(0);
    const [canOpenDuty, setOpenDuty] = useState(true);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    
    const getCurrentDayIndex = () => {
        const day = new Date().getDay();
        return day === 0 ? 6 : day - 1; 
    };
    
    const loadInitialState = () => {
      const savedStartTime = localStorage.getItem("startTime");
      const savedElapsedTime = localStorage.getItem("elapsedTime");
      const savedIsRunning = localStorage.getItem("isRunning") === "true";
      const savedData = localStorage.getItem("timerData");
    
      if (savedStartTime && savedIsRunning) {
        const now = Date.now();
        const elapsed = Math.floor((now - Number(savedStartTime)) / 1000);
        setStartTime(Number(savedStartTime));
        setIsRunning(true);
        setElapsedTime(elapsed); 
      } else if (savedElapsedTime) {
        setElapsedTime(Number(savedElapsedTime));
      }
    
      if (savedData) {
        setData(JSON.parse(savedData));
      }
    };
    
    const saveToLocalStorage = (key: string, value: any) => {
      localStorage.setItem(key, JSON.stringify(value));
    };
    
    useEffect(() => {
      loadInitialState(); 
    
      return () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
      };
    }, []);
    
    useEffect(() => {
      if (isRunning && startTime !== null) {
        intervalRef.current = setInterval(() => {
          setElapsedTime((prev) => prev + 1); 
        }, 1000);
      } else if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    
      return () => {
        if (intervalRef.current) clearInterval(intervalRef.current); 
      };
    }, [isRunning, startTime]);
    
    const startTimer = async () => {
        if (getDiscordIDType(myDiscordID) === "pol" || getDiscordIDType(myDiscordID) === "pen") {
            if (canOpenDuty === false) {
                toast.error("Așteaptă să ți se salveze pontajul!");
                return;
            }
            if (isRunning) return;
            const now = Date.now();
            const currentDayIndex = getCurrentDayIndex();

            try {
                const response = await makeAuthenticatedRequest(`${API_URL}/duty/start`, {
                    callsign: getDiscordIDType(myDiscordID) === 'pol' ? getPoliceDiscordMemberInfo(myDiscordID, "callsign") : getPenDiscordMemberInfo(myDiscordID, "callsign"), 
                    dayIndex: currentDayIndex, 
                    status: "running", 
                    type: getDiscordIDType(myDiscordID)
                });
                if (response.statusText === "OK") {
                    setStartTime(now);
                    setIsRunning(true);
                    saveToLocalStorage("startTime", now);
                    saveToLocalStorage("isRunning", true);
                    saveToLocalStorage("dayIndex", currentDayIndex)
                    toast.success("Ai pornit pontajul!");
                } else {
                    toast.error("A apărut o eroare! Nu s-a putut salva timpul de început.");
                }
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A apărut o eroare! Nu s-a putut salva timpul de început.");
                }
            }
        } else {
            toast.error("Nu poți deschide pontajul!");
        }
    };
    
    const stopTimer = async () => {
        if (!isRunning || startTime === null) return;
        setOpenDuty(false);
        const now = Date.now();
        const currentElapsedTime = Math.floor((now - startTime) / 1000); 
        const roundedMinutes = Math.round(currentElapsedTime / 60);
        const currentDayIndex = getCurrentDayIndex();

        setIsRunning(false);
        setStartTime(null);
        saveToLocalStorage("elapsedTime", 0);
        saveToLocalStorage("isRunning", false);

        const updatedData = [...data];
        updatedData[currentDayIndex] += roundedMinutes;
        if (roundedMinutes < 5) {
            try {
                await makeAuthenticatedRequest(`${API_URL}/duty/stop`, {
                    callsign: getDiscordIDType(myDiscordID) === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "callsign") : getPenDiscordMemberInfo(myDiscordID, "callsign"), 
                    dayIndex: localStorage.getItem("dayIndex") || currentDayIndex, 
                    givenMinutes: 0, 
                    type: getDiscordIDType(myDiscordID)
                });
            
                toast.error("Pontajul minim de 5 minute nu a fost îndeplinit!");
                return;
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A apărut o eroare la ștergerea pontajului.");
                }
            }
            setElapsedTime(0);
            return;
        }

        try {
            const response = await makeAuthenticatedRequest(`${API_URL}/duty/stop`, {
                callsign: getDiscordIDType(myDiscordID) === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "callsign") : getPenDiscordMemberInfo(myDiscordID, "callsign"), 
                dayIndex: localStorage.getItem("dayIndex") || currentDayIndex, 
                givenMinutes: roundedMinutes, 
                type: getDiscordIDType(myDiscordID)
            });
            if (response.data.msg === "OK") {
                setData(updatedData);
                saveToLocalStorage("timerData", updatedData);
                toast.success("Pontajul a fost salvat!");
                setOpenDuty(true);
            } else if (response.data.msg === "CANCELED") {
                toast.error("Pontajul ți-a fost anulat! Acesta nu a fost salvat.")
            } else {
                toast.error("A apărut o eroare! Pontajul nu a fost salvat.");
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A apărut o eroare! Pontajul nu a fost salvat.");
            }
        }
        setElapsedTime(0); 
    };
    
    const formatTime = (seconds: number) => {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${hours} ore, ${minutes} minute, și ${secs} secunde`;
    };
    
    const deleteHRHistory = async () => {
        const result = await Swal.fire({
            title: `Ești sigur că vrei să ștergi istoricul HR?`,
            text: `Această acțiune este ireversibilă!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });

                    
        if (!result.isConfirmed) {
            toast.success("Ai anulat acțiunea de ștergere istoric!");
            return;
        } else {
            try {
                const response = await makeAuthenticatedRequest(`${API_URL}/deleteHistory`, {});
                if (response.statusText === "OK") {
                    toast.success("Istoricul a fost șters!")
                    setLogs([]);
                } else {
                    toast.error("A apărut o eroare! Istoricul nu a fost șters.")
                }
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A apărut o eroare! Istoricul nu a fost șters.")
                }
            }
        }
    }

    const handleInvoiriOpen = async () => {
        try {
            const response = await axios.get(`${API_URL}/get/invoiri`);
            if (response) {
                setActiveInvoiri(response.data);
                setActiveInvoiriOpen(true);
            }
        } catch (err) {
            console.log(err);
            toast.error("A apărut o eroare! Pagina de învoiri nu s-a putut deschide.");
        }
    }

    const handleInvoiriClose = () => {
        setActiveInvoiriOpen(false);
    }

    const acceptInvoire = async (callsign: number, type: string) => {
        try {
            const response = await makeAuthenticatedRequest(`${API_URL}/requests/acceptInvoire`, {
                callsign: callsign,
                type: type
            });
            if (response.statusText) {
                handleInvoiriOpen()
                toast.success("Cererea de învoire a fost acceptată!")
            } else {
                toast.error("A apărut o eroare! Învoirea nu a fost acceptată.")
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A apărut o eroare! Învoirea nu a fost acceptată.")
            }
        }
    }

    const rejectInvoire = async (callsign: number, type: string) => {
        try {
            const response = await makeAuthenticatedRequest(`${API_URL}/requests/rejectInvoire`, {
                callsign: callsign,
                type: type
            });
            if (response.statusText) {
                handleInvoiriOpen()
                toast.success("Cererea de învoire a fost respinsă!")
            } else {
                toast.error("A apărut o eroare! Învoirea nu a fost respinsă.")
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A apărut o eroare! Învoirea nu a fost respinsă.")
            }
        }
    }

    const [contestatieModalOpen, setContestatieModalOpen] = useState(false);
    const [contestatieType, toggleContestatieType] = useState("test");
    const [contestatieTest, setTestContest] = useState("");
    const [contestatieAmenda, setAmendaContestatie] = useState("");
    const [testerName, setTesterName] = useState("");
    const [contestatieDovada, setContestatieDovada] = useState("");
    const [activeContestatii, setActiveContestatii] = useState<Contestatie[]>([]);
    const [activeContestatiiModalOpen, setActiveContestatiiModalOpen] = useState(false);
    const [colegDate, setColegDate] = useState("");
    const [colegDescriere, setColegDescriere] = useState("");

    const openContestatieModal = () => {
        setContestatieModalOpen(true);
    }

    const handleContestatiiClose = () => {
        setContestatieModalOpen(false);
        setTestContest("");
        setTesterName("");
        setAmendaContestatie("");
        setContestatieDovada("");
    }

    const sendContestatie = async () => {
        if (contestatieType) {
            if (testerName !== "" && contestatieDovada !== "") {
                try {
                    const response = await makeAuthenticatedRequest(`${API_URL}/contestatie/create`, {
                        callsign: getDiscordIDType(myDiscordID) === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "callsign") : getPenDiscordMemberInfo(myDiscordID, "callsign"),
                        type: getDiscordIDType(myDiscordID),
                        contestatie: contestatieTest !== "" ? contestatieTest : contestatieAmenda || "coleg",
                        nume: testerName,
                        dovada: contestatieDovada,
                        data: colegDate,
                        descriere: colegDescriere
                    })
                    if (response.statusText === "OK") {
                        toast.success("Contestația a fost trimisă către conducere!");
                        handleContestatiiClose();
                    } else {
                        toast.error("A apărut o eroare! Contestația nu a fost trimisă.");
                        return;
                    }
                } catch (err: any) {
                    if (err.response.data.error === "Invalid token") {
                        toast.error("Token invalid! Te rugăm să te reconectezi.");
                        localStorage.removeItem("token");
                    } else {
                        toast.error("A apărut o eroare! Contestația nu a fost trimisă.");
                    }
                }
            } else {
                toast.error("Toate câmpurile sunt obligatorii!");
                return;
            }
        } else {
            toast.error("Selectează un tip de contestație!");
        }
    }

    const handleContestatiiOpen = async () => {
        try {
            const response = await axios.get(`${API_URL}/contestatie/get`);
            if (response && response.data) {
                setActiveContestatii(response.data || []);
            }
        } catch (err) {
            console.log(err);
            toast.error("A apărut o eroare! Lista nu s-a putut încărca.")
        }
        setActiveContestatiiModalOpen(true);
    }

    const handleActiveContestatiiClose = () => {
        setActiveContestatiiModalOpen(false);
    }

    const deleteContestatie = async (callsign: number, tip: string, tipcontestatie: string, nume: string) => {
        try {
            const response = await makeAuthenticatedRequest(`${API_URL}/contestatie/delete`, {
                callsign: callsign,
                tip: tip,
                tipcontestatie: tipcontestatie,
                nume: nume,
                hrDiscordID: myDiscordID
            });
            if (response.statusText === "OK") {
                toast.success("Contestație ștearsă cu succes!");
                handleContestatiiOpen();
            } else {
                toast.error("A apărut o eroare! Contestația nu a fost ștearsă.")
                return;
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A apărut o eroare! Contestația nu a fost ștearsă.")
            }
        }
    }

    const setStatus = async () => {
        if (dutyStatus === "REMOVE") {
            try {
                await makeAuthenticatedRequest(`${API_URL}/duty/setStatus`, {
                    callsign: getDiscordIDType(myDiscordID) === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "callsign") : getPenDiscordMemberInfo(myDiscordID, "callsign"),
                    status: null,
                    type: getDiscordIDType(myDiscordID)
                })
                toast.success("Ai scos statusul cu succes!");
                handleStatusModalClose();
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A apărut o eroare! Statusul nu a fost setat.");
                    return;
                }
            }
        } else {
            if (dutyStatus !== "") {
                try {
                    await makeAuthenticatedRequest(`${API_URL}/duty/setStatus`, {
                        callsign: getDiscordIDType(myDiscordID) === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "callsign") : getPenDiscordMemberInfo(myDiscordID, "callsign"),
                        status: dutyStatus,
                        type: getDiscordIDType(myDiscordID)
                    })
                    toast.success("Statusul a fost setat cu succes!");
                    handleStatusModalClose();
                } catch (err: any) {
                    if (err.response.data.error === "Invalid token") {
                        toast.error("Token invalid! Te rugăm să te reconectezi.");
                        localStorage.removeItem("token");
                    } else {
                        toast.error("A apărut o eroare! Statusul nu a fost setat.");
                        return;
                    }
                }
            } else {
                toast.error("Statusul introdus nu este valid!");
            }
        }
    }

    const handleStatusModalClose = () => {
        openStatusModal(false);
        dutyStatus = "";
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className={`dark w-full h-full flex flex-col gap-3 box-border`}>
                <HeaderBar currentPage="Pagina Principală"/>
                <div className="w-full h-[87%] box-border pr-[1%] pb-[1%] flex flex-row justify-between">
                    <div className="w-[49.8%] h-full flex flex-col gap-[1%]">
                        <div className="w-full h-[20%]  bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex items-center justify-center gap-[1%]">
                            <div className="w-[31.6%] h-[88%]  bg-[#323232] rounded-[.5vw] flex flex-col items-center">
                                <span className="textBold  text-[#ffffff] text-[1.2vw] mt-[1%]">Total Polițiști</span>
                                <span className="textBold  text-[#ffffff] text-[4vw] mt-[-2%]">{policeMembersData.length}<span className="text-[#7E7E7E] textRegular text-[1vw]">/300</span></span>
                            </div>
                            <div className="w-[31.6%] h-[88%]  bg-[#323232] rounded-[.5vw] flex flex-col items-center">
                                <span className="textBold  text-[#ffffff] text-[1.2vw] mt-[1%]">Total Penitenciar</span>
                                <span className="textBold  text-[#ffffff] text-[4vw] mt-[-2%]">{penitenciarMembersData.length}<span className="text-[#7E7E7E] textRegular text-[1vw]">{penitenciarMembersData.length > 150 ? `/${penitenciarMembersData.length}` : "/150"}</span></span>
                            </div>
                            <div className="w-[31.6%] h-[88%]  bg-[#323232] rounded-[.5vw] flex flex-col items-center">
                                <span className="textBold  text-[#ffffff] text-[1.2vw] mt-[1%]">Amenzi ACTIVE</span>
                                <span className="textBold  text-[#ffffff] text-[4vw] mt-[-2%]">{activeFines}</span>
                            </div>
                        </div>
                        <div className="w-full h-[22%]  bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex flex-col items-center">
                            <span className="w-full h-[20%] flex items-center justify-center textBold  text-[#ffffff] text-[1vw]">Cereri Inactivitate/Demisie</span>
                            <div className="w-[97%] h-[75%] gap-[1%]  bg-[#323232] rounded-[.8vw] flex items-center justify-center">
                                <div onClick={openConcediuModal} className="cursor-pointer w-[23%] h-[60%] pl-[5%] pr-[5%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                    <span className="textBold text-white text-[1.1vw] text-center">CERERE CONCEDIU</span>
                                </div>
                                <div onClick={openDemisieModal} className="cursor-pointer w-[23%] h-[60%] pl-[5%] pr-[5%] flex items-center justify-center bg-gradient-to-r from-[#d80f0f] to-[#f51818] rounded-[.5vw]">
                                    <span className="textBold text-white text-[1.1vw] text-center">CERERE DEMISIE</span>
                                </div>
                                <div onClick={openInvoireModal} className="cursor-pointer w-[23%] h-[60%] pl-[5%] pr-[5%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                    <span className="textBold text-white text-[1.1vw] text-center">CERERE ÎNVOIRE</span>
                                </div>
                                <div onClick={openContestatieModal} className="cursor-pointer w-[23%] h-[60%] pl-[5%] pr-[5%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                    <span className="textBold text-white text-[1.1vw] text-center">CONTESTAȚIE</span>
                                </div>
                            </div>
                        </div>
                        <div className="w-full h-[56%]  bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex flex-col items-center">
                            <div className="w-[97%] h-[15%] flex items-center justify-between">
                                <span className="textSemiBold  text-[#ffffff] text-[1vw]">Calculator Pontaje</span>
                                <div className="w-[60%] h-[80%] flex items-center justify-end gap-[2%]">
                                    <button onClick={() => openStatusModal(true)} disabled={!isRunning} className="bg-[#d0753488] w-[22%] h-[80%] rounded-full flex items-center justify-center gap-[5%] cursor-pointer">
                                        <span className="textRegular text-white text-[0.9vw]">STATUS</span>
                                    </button>
                                    <button onClick={startTimer} disabled={isRunning} className="bg-[#3CD03488] w-[28%] h-[80%] rounded-full flex items-center justify-center gap-[5%] cursor-pointer">
                                        <FontAwesomeIcon className="text-white text-[1vw]" icon={faStopwatch} />
                                        <span className="textRegular text-white text-[0.9vw]">ON-DUTY</span>
                                    </button>
                                    <button onClick={stopTimer} disabled={!isRunning} className="bg-[#D0343488] w-[28%] h-[80%] rounded-full flex items-center justify-center gap-[5%] cursor-pointer">
                                        <FontAwesomeIcon className="text-white text-[0.9vw]" icon={faClock} />
                                        <span className="textRegular text-white text-[0.9vw]">OFF-DUTY</span>
                                    </button>
                                </div>
                            </div>
                            <div className="w-[97%] h-[83%]  bg-[#323232] rounded-[0.9vw] flex flex-col box-border p-[1.5%]">
                                <span className="textBold  text-[#ffffff] text-[1vw]">Pontaj activ: {formatTime(elapsedTime)}</span>
                                <LineChart
                                    xAxis={[
                                        {
                                            scaleType: "band",
                                            data: ["Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă", "Duminică"],
                                        },
                                    ]}
                                    series={[
                                        {
                                            data: data,
                                            area: true,
                                            color: "orange",
                                        },
                                    ]}
                                    sx={{
                                        [`.${axisClasses.root}`]: {
                                          [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                                            stroke: '#ffffff',
                                            strokeWidth: 1,
                                          },
                                          [`.${axisClasses.tickLabel}`]: {
                                            fill: '#ffffff',
                                          },
                                        },
                                        "& .MuiAreaElement-root": {
                                          fill: "url(#darkGradient)",
                                        }
                                      }}
                                    slotProps={{ legend: { hidden: true } }} 
                                    className="w-full h-full"
                                />
                            <svg width={0} height={0}>
                                    <defs>
                                        <linearGradient id="lightGradient" x1="0" y1="0" x2="1" y2="0">
                                            <stop offset="0%" stopColor="#D99564" /> 
                                            <stop offset="100%" stopColor="#F6BF79" /> 
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <svg width={0} height={0}>
                                    <defs>
                                        <linearGradient id="darkGradient" x1="0" y1="0" x2="1" y2="0">
                                            <stop offset="0%" stopColor="#D8630F" /> 
                                            <stop offset="100%" stopColor="#F59318" /> 
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="w-[49.8%] h-full flex flex-col justify-between">
                        <div className="w-full h-[50%]  bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex items-center justify-center">
                            <div className="w-[97%] h-[93%]  bg-[#323232] rounded-[0.9vw] flex items-center justify-center gap-[0.5%]">
                                <div className="w-[48%] h-[98%] flex flex-col items-center gap-[2%]">
                                    <span className="textSemiBold text-[1.2vw] text-center  text-white">Atribuții</span>
                                    <div className="w-full h-full flex flex-col text-base/3">
                                        {myData?.functions ? (
                                            (() => {
                                                const functions = typeof myData.functions === 'string' 
                                                    ? JSON.parse(myData.functions) 
                                                    : myData.functions; 
                                                return Object.entries(functions).map(([key, value]) => (
                                                    <div key={key} className="w-[98%] h-[9%] flex flex-row items-center justify-between">
                                                        <span className="textSemiBold text-[1vw]  text-white">
                                                            {key.charAt(0).toUpperCase() + key.slice(1)}
                                                        </span>
                                                        <span className="textSemiBold text-[#0080D0] text-[1vw]">
                                                            {typeof value === 'string' ? value : value ? 'DA' : 'NU'}
                                                        </span>
                                                    </div>
                                                ));
                                            })()
                                        ) : (
                                            <div className="textMedium  text-white text-[1vw] w-full h-full flex items-center justify-center">
                                                Nu ai nicio funcție atribuită.
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="w-[1px] h-[90%] bg-[#929292]"></div>
                                <div className="w-[48%] h-[98%] flex flex-col items-center gap-[2%]">
                                    <span className="textSemiBold text-[1.2vw] text-center  text-white">Certificate</span>
                                    <div className="w-full h-full flex flex-col">
                                        {myData?.certificates ? (
                                            (() => {
                                                const certificates = typeof myData.certificates === 'string' 
                                                    ? JSON.parse(myData.certificates) 
                                                    : myData.certificates;  
                                                return Object.entries(certificates).map(([key, value]) => ( 
                                                    <div key={key} className="w-[98%] h-[9%] flex flex-row items-center justify-between">
                                                        <span className="textSemiBold text-[1vw]  text-white">
                                                            {key.charAt(0).toUpperCase() + key.slice(1)} 
                                                        </span>
                                                        <span className="textSemiBold text-[#0080D0] text-[1vw]">
                                                            {typeof value === 'string' ? value : value ? 'DA' : 'NU'} 
                                                        </span>
                                                    </div>
                                                ));
                                            })()
                                        ) : (
                                            <div className="textMedium  text-white text-[1vw] w-full h-full flex items-center justify-center">
                                                Nu ai niciun certificat.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full h-[20%]  bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex flex-col items-center">
                            <span className="w-full h-[25%] flex items-center justify-center textBold  text-[#ffffff] text-[1vw]">Cereri Active</span>
                            <div className="w-[97%] h-[70%]  bg-[#323232] rounded-[.8vw] flex items-center justify-center gap-[1%]">
                                {isConducere ? (
                                    <>
                                        <div onClick={handleConcediiOpen} className="cursor-pointer w-[23.5%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                            <span className="textBold text-white text-[1.1vw] text-wrap text-center">CERERI CONCEDIU</span>
                                        </div>
                                        <div onClick={openDemisiiModal} className="cursor-pointer w-[23.5%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#d80f0f] to-[#f51818] rounded-[.5vw]">
                                            <span className="textBold text-white text-[1.1vw] text-wrap text-center">CERERI DEMISIE</span>
                                        </div>
                                        <div onClick={handleInvoiriOpen} className="cursor-pointer w-[23.5%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                            <span className="textBold text-white text-[1.1vw] text-wrap text-center">CERERI ÎNVOIRI</span>
                                        </div>
                                        <div onClick={handleContestatiiOpen} className="cursor-pointer w-[23.5%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                            <span className="textBold text-white text-[1.1vw] text-wrap text-center">CONTESTAȚII</span>
                                        </div>
                                    </>
                                ) : myData?.functions?.['responsabil concedii'] === true ? (
                                    <div onClick={handleConcediiOpen} className="cursor-pointer w-[45%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                        <span className="textBold text-white text-[1.3vw]">CERERI CONCEDIU</span>
                                    </div>
                                ) : (
                                    <span className=" text-white textSemiBold text-[1vw]">Nu ai acces să vezi această secțiune!</span>
                                )}
                            </div>
                        </div>
                        <div className="w-full h-[28%]  bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex flex-col items-center">
                            <span className="w-full h-[15%] flex items-center justify-center textBold  text-[#ffffff] text-[1vw]">Istoric Actiuni</span>
                            {isConducere === true && (
                                <div onClick={deleteHRHistory} className="cursor-pointer absolute right-[2%] top-[1%] px-[2%] bg-gradient-to-r from-[#d80f0f] to-[#f51818] rounded-[.2vw]">
                                    <span className="textMedium text-white text-[0.7vw]">Șterge Istoric</span>
                                </div>
                            )}
                            <div className="w-[97%] h-[80%]  bg-[#323232] rounded-[.8vw] flex flex-col items-center overflow-y-scroll">
                                {logsHR.map((log, index) => (
                                    log.type === "SANCTIUNE" ? (
                                        <div key={index} className="w-full min-h-[30%] border-b-[1px] border-[#D0D0D0] flex flex-row items-center justify-between box-border pl-[2%] pr-[2%] gap-[2%]">
                                            <div className="w-[65%] h-full flex items-center gap-[2%]">
                                                <span className="textBold gradient-text text-[1.1vw] min-w-fit">
                                                SANCȚIUNE <span className="stop-gradient textSemiBold background-none  text-white text-[1vw]">{log.member}</span>
                                                </span>
                                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                                <span className="textMedium text-[0.8vw] min-w-fit text-[#797979]">{log.date_time}</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div key={index} className="w-full min-h-[30%] border-b-[1px] border-[#D0D0D0] flex flex-row items-center justify-between box-border pl-[2%] pr-[2%] gap-[2%]">
                                            <div className="w-[65%] h-full flex items-center gap-[2%]">
                                                <span className={`textBold ${log.type === "ADMITERE" ? "text-[#0fd830]" : log.type === "UPDATE ATRIBUȚII" ? "text-[#d8c10f]" : "text-[#d80f0f]"} text-[1.1vw] min-w-fit`}>
                                                {log.type}: <span className="textSemiBold  text-white text-[1vw]">{log.member}</span>
                                                </span>
                                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                                <span className="textMedium text-[0.8vw] min-w-fit text-[#797979]">{log.date_time}</span>
                                            </div>
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>                        
                    </div>
                </div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={openConcediu}
                    onClose={handleCloseModal}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={openConcediu}>
                    <Box sx={concediuStyle} className="flex flex-col">
                        <span className=" text-white textSemiBold text-[1vw] w-full text-center">CERERE CONCEDIU</span>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                if (!startDate || !endDate) {
                                    toast.error("Completează datele de începere/terminare a concediului!")
                                    return;
                                }
                                handleConcediuSubmit(e);
                            }}
                            className="w-full h-full flex items-center flex-col gap-[5%] box-border pt-[2%]"
                            >
                            <DatePicker
                                className="w-[50%]"
                                value={startDate ? dayjs(startDate) : null}
                                onChange={(date: Dayjs | null) => setStartDate(date ? date.toDate() : null)}
                                sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                    borderColor: "gray", 
                                    },
                                    "&:hover fieldset": {
                                    borderColor: "lightgray",
                                    },
                                    "&.Mui-focused fieldset": {
                                    borderColor: "orange",
                                    },
                                },
                                "& .MuiInputBase-input": {
                                    color: "white", 
                                },
                                "& .MuiInputLabel-root": {
                                    color: "white", 
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                },
                                "& .MuiSvgIcon-root": {
                                    color: "white", 
                                },
                                "& .MuiOutlinedInput-root.Mui-focused .MuiSvgIcon-root": {
                                    color: "orange",
                                },
                                }}
                                format="DD/MM/YYYY"
                                label="Data incepere inactivitate"
                            />
                            <DatePicker
                                className="w-[50%]"
                                value={endDate ? dayjs(endDate) : null}
                                onChange={(date: Dayjs | null) => setEndDate(date ? date.toDate() : null)}
                                sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                    borderColor: "gray",
                                    },
                                    "&:hover fieldset": {
                                    borderColor: "lightgray",
                                    },
                                    "&.Mui-focused fieldset": {
                                    borderColor: "orange",
                                    },
                                },
                                "& .MuiInputBase-input": {
                                    color: "white",
                                },
                                "& .MuiInputLabel-root": {
                                    color: "white", 
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                },
                                "& .MuiSvgIcon-root": {
                                    color: "white", 
                                },
                                "& .MuiOutlinedInput-root.Mui-focused .MuiSvgIcon-root": {
                                    color: "orange", 
                                },
                                }}
                                format="DD/MM/YYYY"
                                label="Data incheiere concediu"
                            />
                            <TextField
                                required
                                id="standard-required"
                                label="Motiv OOC"
                                variant="standard"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                className="w-[50%]"
                                sx={{
                                "& .MuiInputBase-input": {
                                    color: "white", 
                                },
                                "& .MuiInputLabel-root": {
                                    color: "white", 
                                },
                                "& .MuiInput-underline:before": {
                                    borderBottomColor: "gray", 
                                },
                                "& .MuiInput-underline:after": {
                                    borderBottomColor: "orange", 
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange",
                                },
                                }}
                            />
                            <button
                                type="submit"
                                className="mt-[5%] textBold cursor-pointer w-fit h-[35%] pl-[15%] pr-[15%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]"
                            >
                                <span className="text-[1.1vw] text-white">TRIMITE CERERE</span>
                            </button>
                            </form>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={openDemisie}
                    onClose={handleCloseModal}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={openDemisie}>
                    <Box sx={demisieStyle} className="flex flex-col">
                        <span className=" text-white textSemiBold text-[1vw] w-full text-center">CERERE DEMISIE</span>
                        <form onSubmit={handleDemisieSubmit} className="w-full h-full flex items-center flex-col gap-[2%] box-border pt-[2%]">
                            <TextField
                                required
                                id="standard-required"
                                label="Motiv"
                                onChange={(e) => setReason(e.target.value)}
                                variant="standard"
                                className="w-[50%]"
                                sx={{
                                    "& .MuiInputBase-input": {
                                        color: "white", 
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: "white",
                                    },
                                    "& .MuiInput-underline:before": {
                                        borderBottomColor: "gray",
                                    },
                                    "& .MuiInput-underline:after": {
                                        borderBottomColor: "orange",
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "orange", 
                                    },
                                }}
                            />
                            <button type="submit" className="mt-[5%] textBold cursor-pointer w-fit h-[40%] pl-[15%] pr-[15%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                <span className="text-[1.1vw] text-white">TRIMITE CERERE</span>
                            </button>
                        </form>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={openInvoire}
                    onClose={handleCloseModal}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={openInvoire}>
                    <Box sx={invoireStyle} className="flex flex-col">
                        <span className=" text-white textSemiBold text-[1vw] w-full text-center">CERERE ÎNVOIRE</span>
                        <form onSubmit={handleInvoireSubmit} className="w-full h-full flex items-center flex-col gap-[2%] box-border pt-[2%]">
                            <TextField
                                required
                                id="standard-required"
                                label="Motiv OOC"
                                variant="standard"
                                onChange={(e) => setReason(e.target.value)}
                                className="w-[50%]"
                                sx={{
                                    "& .MuiInputBase-input": {
                                    color: "white", 
                                    },
                                    "& .MuiInputLabel-root": {
                                    color: "white", 
                                    },
                                    "& .MuiInput-underline:before": {
                                    borderBottomColor: "gray", 
                                    },
                                    "& .MuiInput-underline:after": {
                                    borderBottomColor: "orange", 
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                    },
                                }}
                            />
                            <button type="submit" className="mt-[5%] textBold cursor-pointer w-fit h-[40%] pl-[15%] pr-[15%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                <span className="text-[1.1vw] text-white">TRIMITE CERERE</span>
                            </button>
                        </form>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={activeDemisiiOpen}
                    onClose={handleDemisiiClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={activeDemisiiOpen}>
                    <Box sx={activeStyle} className="flex flex-col">
                        <span className=" text-white textSemiBold text-[1vw] w-full text-center">LISTĂ DEMISII ACTIVE</span>
                        <div className="w-[100%] h-full  bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%]">
                        {activeDemisii.map((demisie, index) => (
                            <div key={index} className="w-full min-h-[14%] border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]">
                                <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{demisie.type === 'pol' ? String(demisie.callsign).padStart(3, '0') : `P-${String(demisie.callsign).padStart(2, '0')}`}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{demisie.type === 'pol' ? getPoliceDiscordMemberInfo(getPoliceMemberInfo(Number(demisie.callsign), "discordID"), "full_name") : getPenDiscordMemberInfo(getPenMemberInfo(Number(demisie.callsign), "discordID"), "full_name")}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                {demisie.reason.length > 15 ? (
                                    <div onClick={() => toast.success(`Motiv: ${demisie.reason}`)} className="w-[20%] h-[70%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0e75c4] to-[#18abf5]">
                                        <span className="textBold text-white text-[.8vw]">MOTIV</span>
                                    </div>
                                ) : (
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{demisie.reason}</span>
                                )}
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                <div onClick={() => rejectDemisie(demisie.callsign, demisie.type)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                    <span className="textBold text-white text-[.8vw]">ȘTERGE</span>
                                </div>
                            </div>
                        ))}
                        </div>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={activeConcediiOpen}
                    onClose={handleConcediiClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={activeConcediiOpen}>
                    <Box sx={activeCStyle} className="flex flex-col">
                        <span className=" text-white textSemiBold text-[1vw] w-full text-center">LISTĂ CERERI CONCEDII ACTIVE</span>
                        <div className="w-[100%] h-full  bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%]">
                            {Array.isArray(activeConcedii) && activeConcedii.length > 0 && (
                                activeConcedii.map((concediu, index) => (
                                    <div key={index} className="w-full min-h-[14%] border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]">
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{String(concediu.callsign).padStart(3, '0')}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{concediu.name}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">Zile utilizate: {(14 - getPoliceMemberInfo(concediu.callsign, "concediu")) + concediu.days}/14</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{concediu.startDate}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{concediu.endDate}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    {concediu.reason.length > 15 ? (
                                        <div onClick={() => toast.success(`Motiv: ${concediu.reason}`)} className="w-[10%] h-[70%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0e75c4] to-[#18abf5]">
                                            <span className="textBold text-white text-[.8vw]">MOTIV</span>
                                        </div>
                                    ) : (
                                        <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{concediu.reason}</span>
                                    )}
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    {Boolean(concediu.status) === true ? (
                                        <>
                                            <span className="textBold text-[#0ec423] text-[.8vw]">ACCEPTAT</span>
                                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                            <div onClick={() => rejectConcediu(concediu.callsign, concediu.reason)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">ȘTERGE</span>
                                            </div>
                                        </>
                                    ): (
                                        <>
                                            <div className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0ec423] to-[#18f532]">
                                                <span onClick={() => acceptConcediu(concediu.callsign, concediu.reason, concediu.days)} className="textBold text-white text-[.8vw]">ACCEPTĂ</span>
                                            </div>
                                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                            <div onClick={() => rejectConcediu(concediu.callsign, concediu.reason)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">RESPINGE</span>
                                            </div>
                                        </>
                                    )}
                                    </div>
                                ))
                            )}
                        </div>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={activeInvoiriOpen}
                    onClose={handleInvoiriClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={activeInvoiriOpen}>
                    <Box sx={activeStyle} className="flex flex-col">
                        <span className=" text-white textSemiBold text-[1vw] w-full text-center">LISTĂ ÎNVOIRI ACTIVE</span>
                        <div className="w-[100%] h-full  bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%]">
                            {Array.isArray(activeInvoiri) && activeInvoiri.length > 0 && (
                                activeInvoiri.map((invoire, index) => (
                                <div key={index} className="w-full min-h-[14%] border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]" >
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{invoire.type === 'pol' ? String(invoire.callsign).padStart(3, '0') : `P-${String(invoire.callsign).padStart(2, '0')}`}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{invoire.type === 'pol' ? getPoliceDiscordMemberInfo(getPoliceMemberInfo(invoire.callsign, "discordID"), "full_name") : getPenDiscordMemberInfo(getPenMemberInfo(invoire.callsign, "discordID"), "full_name")}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{invoire.reason}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    {invoire.status ? (
                                        <>
                                            <span className="textBold text-[#0ec423] text-[.8vw] cursor-pointer">ACCEPTAT</span>
                                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                            <div onClick={() => rejectInvoire(invoire.callsign, invoire.type)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">ȘTERGE</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div onClick={() => acceptInvoire(invoire.callsign, invoire.type)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0ec423] to-[#18f532]">
                                                <span className="textBold text-white text-[.8vw]">ACCEPTĂ</span>
                                            </div>
                                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                            <div onClick={() => rejectInvoire(invoire.callsign, invoire.type)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">RESPINGE</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )))}
                        </div>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={contestatieModalOpen}
                    onClose={handleContestatiiClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={contestatieModalOpen}>
                    <Box sx={contestatieStyle} className="flex flex-col">
                        <span className=" text-white textSemiBold text-[1vw] w-full text-center">Depune Contestație</span>
                        <div className="w-[100%] h-full  bg-[#282828] rounded-[0.5vw] flex flex-col items-center justify-center gap-[0.5%]">
                            <div className="w-full h-[10%] flex flex-row items-center justify-center gap-[5%]">
                                <span onClick={() => toggleContestatieType("test")} className={`contestatieSpan ${contestatieType === "test" && "active"} cursor-pointer textBold text-white text-[1.3vw]`}>TEST</span>
                                <span onClick={() => toggleContestatieType("amenda")} className={`contestatieSpan ${contestatieType === "amenda" && "active"} cursor-pointer textBold text-white text-[1.3vw]`}>AMENDĂ</span>
                                <span onClick={() => toggleContestatieType("coleg")} className={`contestatieSpan ${contestatieType === "coleg" && "active"} cursor-pointer textBold text-white text-[1.3vw]`}>COLEG</span>
                            </div>
                            {contestatieType === "test" ? (
                                <div className="w-full h-[72%] flex flex-col items-center justify-center">
                                    <span className="textSemiBold text-white text-[1vw]">Tipul testului:</span>
                                    <div onClick={() => setTestContest("moto")} className="w-[15%] h-[8%] flex flex-row items-center justify-between mt-[1%]">
                                        <span className="textMedium text-white text-[1vw]">MOTO</span>
                                        <div className={`w-[1vw] h-[1vw] ball ${contestatieTest === "moto" && "active"} rounded-full`}></div>
                                    </div>
                                    <div onClick={() => setTestContest("pilot")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                        <span className="textMedium text-white text-[1vw]">PILOT</span>
                                        <div className={`w-[1vw] h-[1vw] ball ${contestatieTest === "pilot" && "active"} rounded-full`}></div>
                                    </div>
                                    <div onClick={() => setTestContest("hs")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                        <span className="textMedium text-white text-[1vw]">HS</span>
                                        <div className={`w-[1vw] h-[1vw] ball ${contestatieTest === "hs" && "active"} rounded-full`}></div>
                                    </div>
                                    <span className="textSemiBold text-white text-[1vw] mt-[2%]">Numele testerului:</span>
                                    <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                        <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                            <input
                                                type="text"
                                                placeholder="..."
                                                value={testerName}
                                                onChange={(e) => setTesterName(e.target.value)}
                                                className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                            />
                                        </div>
                                    </div>
                                    <span className="textSemiBold text-white text-[1vw] mt-[2%]">Dovadă:</span>
                                    <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                        <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                            <input
                                                type="text"
                                                placeholder="Link cu dovada (YT/Medal)"
                                                value={contestatieDovada}
                                                onChange={(e) => setContestatieDovada(e.target.value)}
                                                className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                (contestatieType === "amenda" ? (
                                    <div className="w-full h-[72%] flex flex-col items-center justify-center">
                                        <span className="textSemiBold text-white text-[1vw]">Tipul reclamației:</span>
                                        <div onClick={() => setAmendaContestatie("amenda")} className="w-[15%] h-[8%] flex flex-row items-center justify-between mt-[1%]">
                                            <span className="textMedium text-white text-[1vw]">AMENDĂ</span>
                                            <div className={`w-[1vw] h-[1vw] ball ${contestatieAmenda === "amenda" && "active"} rounded-full`}></div>
                                        </div>
                                        <div onClick={() => setAmendaContestatie("avertisment")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                            <span className="textMedium text-white text-[1vw]">AV</span>
                                            <div className={`w-[1vw] h-[1vw] ball ${contestatieAmenda === "avertisment" && "active"} rounded-full`}></div>
                                        </div>
                                        <div onClick={() => setAmendaContestatie("fw")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                            <span className="textMedium text-white text-[1vw]">FW</span>
                                            <div className={`w-[1vw] h-[1vw] ball ${contestatieAmenda === "fw" && "active"} rounded-full`}></div>
                                        </div>
                                        <span className="textSemiBold text-white text-[1vw] mt-[2%]">Nume membru conducere:</span>
                                        <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                            <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                                <input
                                                    type="text"
                                                    placeholder="..."
                                                    value={testerName}
                                                    onChange={(e) => setTesterName(e.target.value)}
                                                    className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                                />
                                            </div>
                                        </div>
                                        <span className="textSemiBold text-white text-[1vw] mt-[2%]">Dovadă:</span>
                                        <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                            <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                                <input
                                                    type="text"
                                                    placeholder="Link cu dovada (YT/Medal)"
                                                    value={contestatieDovada}
                                                    onChange={(e) => setContestatieDovada(e.target.value)}
                                                    className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="w-full h-[72%] flex flex-col items-center justify-center">
                                        <span className="textSemiBold text-white text-[1vw]">Nume coleg:</span>
                                        <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                            <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                                <input
                                                    type="text"
                                                    placeholder="..."
                                                    value={testerName}
                                                    onChange={(e) => setTesterName(e.target.value)}
                                                    className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                                />
                                            </div>
                                        </div>
                                        <span className="textSemiBold text-white text-[1vw] mt-[1%]">Dovadă:</span>
                                        <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                            <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                                <input
                                                    type="text"
                                                    placeholder="Link cu dovada (YT/Medal)"
                                                    value={contestatieDovada}
                                                    onChange={(e) => setContestatieDovada(e.target.value)}
                                                    className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                                />
                                            </div>
                                        </div>
                                        <span className="textSemiBold text-white text-[1vw] mt-[1%]">Data întâmplării:</span>
                                        <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                            <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                                <input
                                                    type="text"
                                                    placeholder="ex: 15.02.2025"
                                                    value={colegDate}
                                                    onChange={(e) => setColegDate(e.target.value)}
                                                    className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                                />
                                            </div>
                                        </div>
                                        <span className="textSemiBold text-white text-[1vw] mt-[1%]">Descriere:</span>
                                        <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                            <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                                <input
                                                    type="text"
                                                    placeholder="..."
                                                    value={colegDescriere}
                                                    onChange={(e) => setColegDescriere(e.target.value)}
                                                    className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                            <button onClick={() => sendContestatie()} className="textBold cursor-pointer w-fit h-[13%] pl-[7%] pr-[7%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                <span className="text-[1.1vw] text-white">TRIMITE CONTESTAȚIE</span>
                            </button>
                        </div>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={activeContestatiiModalOpen}
                    onClose={handleActiveContestatiiClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={activeContestatiiModalOpen}>
                    <Box sx={activeStyle} className="flex flex-col">
                        <span className=" text-white textSemiBold text-[1vw] w-full text-center">LISTĂ CONTESTAȚII ACTIVE</span>
                        <div className="w-[100%] h-full  bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%]">
                            {Array.isArray(activeContestatii) && activeContestatii.length > 0 && (
                                activeContestatii.map((contestatie, index) => (
                                <div key={index} className="w-full min-h-[14%] border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]" >
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">[{contestatie.tip === "pol" ? String(contestatie.callsign).padStart(3, '0') : String(contestatie.callsign).padStart(2, '0')}] {contestatie.tip === "pol" ? getPoliceMemberInfo(contestatie.callsign, "full_name") : getPenMemberInfo(contestatie.callsign, "full_name")}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{contestatie.tipcontestatie.toUpperCase()}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <a className="textSemiBold w-[15%] text-center underline text-blue-600 text-[0.9vw]" href={contestatie.dovada}>Link Dovadă</a>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[0.9vw] text-[#ffffff]">{contestatie.nume}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                                    <div onClick={() => deleteContestatie(contestatie.callsign, contestatie.tip, contestatie.tipcontestatie, contestatie.nume)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                        <span className="textBold text-white text-[.8vw]">ȘTERGE</span>
                                    </div>
                                </div>
                            )))}
                        </div>
                    </Box>
                    </Fade>
                </Modal>
                <CustomSelectModal
                    statusModal={statusModal}
                    handleStatusModalClose={handleStatusModalClose}
                    handleChangeStatus={(value: any) => console.log("Selected:", value)}
                    setStatus={() => setStatus()}
                    statusStyle={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '40vw',
                        height: '30vh',
                        backgroundColor: '#1E1E1E',
                        borderRadius: '20px',
                        padding: '2%',
                        outline: 'none',
                    }}
                />
            </div>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
        </LocalizationProvider>
    );
}

export default HomePage;